import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'src/app/shared/services/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class MetricasService {
  constructor(private _requestService: RequestService) {}

  listResponsible(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Responsibles`,
      'GET',
      true,
      null
    );
  }

  listActions(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Actions`,
      'GET',
      true,
      null
    );
  }

  listWorkByMarketPhase(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/WorkByMarketPhaseOverview`,
      'POST',
      true,
      data
    );
  }

  listWorkPhaseTable(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/WorkByMarketPhaseWorklist`,
      'POST',
      true,
      data
    );
  }

  listWorkTask(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/WorkByTaskOverview`,
      'POST',
      true,
      data
    );
  }

  listWorkTaskTable(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/WorkByTaskWorklist`,
      'POST',
      true,
      data
    );
  }

  listWorkLostReason(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/WorkByLostReasonOverview`,
      'POST',
      true,
      data
    );
  }

  listWorkLostReasonTable(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/WorkByLostReasonWorklist`,
      'POST',
      true,
      data
    );
  }

  listWorkResponsible(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/WorkByResponsibleOverview`,
      'POST',
      true,
      data
    );
  }

  listWorkResponsibleTable(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/WorkByResponsibleWorklist`,
      'POST',
      true,
      data
    );
  }

  listFilterLostReason(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/LostReasons`,
      'GET',
      true,
      null
    );
  }

  listFilterWorkPhase(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/MarketPhase`,
      'GET',
      true,
      null
    );
  }

  modules(companyID, restrictionKey) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `company/api/Company/GetContractedModules`,
      'GET',
      true,
      null,
      header
    );
  }

  listWorkRegion(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/WorkByRegion`,
      'POST',
      true,
      data
    );
  }

  listComparativeMap(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/Metrics/comparativeMap`,
      'POST',
      true,
      data
    );
  }

  downloadExcelLostReason(data?: any): Observable<any> {
    return this._requestService.request(
      `Export/Excel/Metrics/WorkByLostReason`,
      'POST',
      true,
      data || null,
      undefined,
      'blob'
    );
  }

  downloadExcelComparativeMap(data?: any): Observable<any> {
    return this._requestService.request(
      `Export/Excel/Metrics/comparativeMap`,
      'POST',
      true,
      data || null,
      undefined,
      'blob'
    );
  }

  downloadExcelWorkRegion(data?: any): Observable<any> {
    return this._requestService.request(
      `Export/Excel/Metrics/WorkByRegion`,
      'POST',
      true,
      data || null,
      undefined,
      'blob'
    );
  }


  downloadExcelWorkResponsible(data?: any): Observable<any> {
    return this._requestService.request(
      `Export/Excel/Metrics/WorkByResponsible`,
      'POST',
      true,
      data || null,
      undefined,
      'blob'
    );
  }

    downloadExcelWorkByMarketPhase(data?: any): Observable<any> {
    return this._requestService.request(
      `Export/Excel/Metrics/WorkByMarketPhase`,
      'POST',
      true,
      data || null,
      undefined,
      'blob'
    );
  }

    downloadExcelWorkTask(data?: any): Observable<any> {
    return this._requestService.request(
      `Export/Excel/Metrics/WorkByTask`,
      'POST',
      true,
      data || null,
      undefined,
      'blob'
    );
  }

}
